import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import ConfigProvider from '../config-provider';
import ModalPortal from './ModalPortal';

var Modal = function Modal(props) {
  var customizePrefixCls = props.prefixCls,
      getPopupContainer = props.getPopupContainer,
      className = props.className;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      container = _useState2[0],
      setContainer = _useState2[1];

  var _React$useContext = React.useContext(ConfigProvider.ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls;

  var prefixCls = getPrefixCls('modal', customizePrefixCls);

  var createContainer = function createContainer() {
    var newContainer = document.createElement('div');
    newContainer.className = classnames(prefixCls, className);
    var mountNode = getPopupContainer ? getPopupContainer() : document.body;
    mountNode.appendChild(newContainer);
    setContainer(newContainer);
  };

  var removeContainer = function removeContainer() {
    if (container) {
      container.parentNode.removeChild(container);
    }
  };

  useEffect(function () {
    createContainer();
    return function () {
      removeContainer();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (container) {
    return (
      /*#__PURE__*/
      ReactDOM.createPortal(
      /*#__PURE__*/
      React.createElement(ModalPortal, props), container)
    );
  }

  return null;
};

export default Modal;